let _counter = 0;

export default function newId() {
  return (_counter += 1);
}
